import { DataType } from "@/jenesys-types/data/enums";

export enum RelationshipType {
  OneToMany = "ONE_TO_MANY",
  OneToOne = "ONE_TO_ONE"
}

interface RelationshipConfig {
  foreignKey: string;
  dataType: DataType;
  type: RelationshipType;
}

interface EntityConfig {
  relationships: Partial<Record<string, RelationshipConfig>>;
}

const entities: Record<DataType, EntityConfig> = {
  [DataType.Company]: {
    relationships: {}
  },
  [DataType.CompanyBillingDetails]: {
    relationships: {}
  },
  [DataType.Client]: {
    relationships: {}
  },
  [DataType.Clients]: {
    relationships: {}
  },
  [DataType.Transaction]: {
    relationships: {}
  },
  [DataType.Reconciliation]: {
    relationships: {}
  },
  [DataType.Transactions]: {
    relationships: {}
  },
  [DataType.User]: {
    relationships: {}
  },
  [DataType.HubSpotToken]: {
    relationships: {}
  },
  [DataType.Notification]: {
    relationships: {}
  },
  [DataType.Settings]: {
    relationships: {}
  },
  [DataType.Summary]: {
    relationships: {}
  },
  [DataType.Update]: {
    relationships: {}
  },
  [DataType.Team]: {
    relationships: {}
  },
  [DataType.Banks]: {
    relationships: {}
  },
  [DataType.Department]: {
    relationships: {}
  },
  [DataType.Integrations]: {
    relationships: {}
  },
  [DataType.Accounting]: {
    relationships: {}
  },
  [DataType.AccountingShort]: {
    relationships: {}
  },
  [DataType.AccountingIntegration]: {
    relationships: {}
  },
  [DataType.IntegrationAuth]: {
    relationships: {}
  },
  [DataType.YapilyAuth]: {
    relationships: {}
  },
  [DataType.MailAuth]: {
    relationships: {}
  },
  [DataType.IntegrationRefresh]: {
    relationships: {}
  },
  [DataType.IntegrationDisconnect]: {
    relationships: {}
  },
  [DataType.WhatsappDisconnect]: {
    relationships: {}
  },
  [DataType.WhatsappNumber]: {
    relationships: {}
  },
  [DataType.MailDisconnect]: {
    relationships: {}
  },
  [DataType.ChartOfAccounts]: {
    relationships: {}
  },
  [DataType.EmailStatus]: {
    relationships: {}
  },
  [DataType.WhatsappStatus]: {
    relationships: {}
  },
  [DataType.DisconnectMember]: {
    relationships: {}
  },
  [DataType.InviteMember]: {
    relationships: {}
  },
  [DataType.LinkBusiness]: {
    relationships: {}
  },
  [DataType.UploadDocuments]: {
    relationships: {}
  },
  [DataType.DocumentsStatus]: {
    relationships: {}
  },
  [DataType.BulkPublishing]: {
    relationships: {}
  },
  [DataType.BankConnections]: {
    relationships: {}
  },
  [DataType.ConnectionDuration]: {
    relationships: {}
  },
  [DataType.BankStatement]: {
    relationships: {}
  },
  [DataType.BankStatementUploads]: {
    relationships: {}
  },
  [DataType.EmailForwardingSender]: {
    relationships: {}
  },
  [DataType.BankStatementDocument]: {
    relationships: {}
  },
  [DataType.LineItemExtraction]: {
    relationships: {}
  },
  [DataType.UpdateWhatsappNumber]: {
    relationships: {}
  },
  [DataType.DocumentPreview]: {
    relationships: {}
  },
  [DataType.Template]: {
    relationships: {}
  },
  [DataType.CommunicationsQuery]: {
    relationships: {}
  },
  [DataType.DocumentQuery]: {
    relationships: {}
  },
  [DataType.Chaser]: {
    relationships: {}
  }
};

export const getRelationship = (
  dataType: DataType,
  name: string
): RelationshipConfig => {
  const relationship = entities[dataType].relationships?.[name];

  if (!relationship) {
    throw new Error(`Unable to find relationship ${name} on ${dataType}`);
  }

  return relationship;
};

export default entities;
